/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const InlineFeedbackAnalyticsDataParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('inline-feedback')],
    ['totalAmount', codecNumber, 'total_amount'],
]);
export class InlineFeedbackAnalyticsData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return InlineFeedbackAnalyticsDataParser.decode(input).map(res => new InlineFeedbackAnalyticsData(res));
    }
    static unsafeDecode(input) {
        return InlineFeedbackAnalyticsData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InlineFeedbackAnalyticsDataParser.encode(data);
    }
    static schema() {
        return InlineFeedbackAnalyticsDataParser.schema();
    }
}
